import { render, staticRenderFns } from "./dtyy.vue?vue&type=template&id=332effc2&scoped=true"
import script from "./dtyy.vue?vue&type=script&lang=js"
export * from "./dtyy.vue?vue&type=script&lang=js"
import style0 from "./dtyy.vue?vue&type=style&index=0&id=332effc2&prod&lang=less&scoped=true"
import style1 from "./dtyy.vue?vue&type=style&index=1&id=332effc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332effc2",
  null
  
)

export default component.exports